import React from "react";
// @ts-ignore
import {CSSTransition} from 'react-transition-group';
import './WrapperAnimations.css'

const withLoadingAnimation = (component: any, loadingComponent: any, allDataLoaded: boolean) => {
    return (
        <CSSTransition
            in={allDataLoaded}
            timeout={500}
            classNames="alert">
            { allDataLoaded ? component : loadingComponent}
        </CSSTransition>
    )
};


export default withLoadingAnimation;
